import { FC, useCallback } from 'react';
import { useDispatch } from 'react-redux';

import { useTranslate } from 'hooks/useTranslate';

import sizes from 'constants/sizes';
import { setModal } from 'modules/_shared/redux/modalActions';
import EditIncentivesMarketSharePurchaseContractTemplateModal from 'modules/incentivesMarket/modals/EditIncentivesMarketSharePurchaseContractTemplate';
import { EditIncentivesMarketSharePurchaseContractTemplateModalProvider } from 'modules/incentivesMarket/modals/EditIncentivesMarketSharePurchaseContractTemplate/context/EditIncentivesMarketSharePurchaseContractTemplateModalContext';

type IncentivesMarketAdminPanelConfigurationSharePurchaseContractProps = {
  societyId: string;
};

const IncentivesMarketAdminPanelConfigurationSharePurchaseContract: FC<
  IncentivesMarketAdminPanelConfigurationSharePurchaseContractProps
> = ({ societyId }) => {
  const { t } = useTranslate();
  const dispatch = useDispatch();

  const handleOpenContractTemplateModal = useCallback(() => {
    dispatch(
      setModal(
        <EditIncentivesMarketSharePurchaseContractTemplateModalProvider
          societyId={societyId}
          size={sizes.XL}
        >
          <EditIncentivesMarketSharePurchaseContractTemplateModal />
        </EditIncentivesMarketSharePurchaseContractTemplateModalProvider>
      )
    );
  }, [dispatch, societyId]);

  return (
    <div className="card card-bordered mb-4">
      <div className="card-inner">
        <h6 className="card-title mb-1">
          <em className="icon ni ni-file-text mr-2 text-primary" />
          {t('IncentivesMarketAdminConfigSection2Title')}
        </h6>
        <p className="text-soft fs-13px mb-4">
          {t('IncentivesMarketAdminConfigSection2Description')}
        </p>
        <div className="doc-item align-items-start align-items-md-center">
          <div className="doc-icon bg-warning-dim text-warning">
            <em className="icon ni ni-file-text" />
          </div>
          <div className="flex-grow-1">
            <strong className="fs-13px d-block">
              {t('IncentivesMarketAdminConfigContractTitle')}
            </strong>
            <div className="text-soft fs-12px">
              {t('IncentivesMarketAdminConfigContractSubtitle')}
            </div>
          </div>
          <div className="flex-shrink-0 mt-3 mt-md-0 ml-md-3">
            <button
              type="button"
              className="btn btn-primary btn-sm"
              onClick={handleOpenContractTemplateModal}
            >
              {t('Edit')}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default IncentivesMarketAdminPanelConfigurationSharePurchaseContract;
